<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-text-field
        v-model.trim="userModel.surname"
        :rules="surnameRules"
        label="Фамилия"
        autofocus
        required
      />
    </v-col>

    <v-col cols="12" sm="6">
      <v-text-field
        v-model.trim="userModel.name"
        :rules="nameRules"
        label="Имя"
        required
      />
    </v-col>

    <v-col cols="12">
      <v-text-field v-model="userModel.patronymic" label="Отчество" />
    </v-col>

    <v-col cols="12">
      <employment-choose :group="group" @update="getCategoryList" />
    </v-col>
  </v-row>
</template>

<script>
import EmploymentChoose from "./EmploymentChoose";
export default {
  name: "AdditionForm",
  components: { EmploymentChoose },
  props: {
    value: { required: true, type: Object },
    group: { type: String, default: () => "" }
  },

  data() {
    return {
      surnameRules: [v => !!v || "Это обязательное поле"],
      nameRules: [v => !!v || "Это обязательное поле"],
      userModel: { ...this.value }
    };
  },

  watch: {
    userModel: {
      handler(newValue) {
        this.$emit("input", newValue);
      },
      deep: true
    }
  },

  methods: {
    getCategoryList(employment) {
      this.$emit("update", employment);
    }
  }
};
</script>
